import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[150]};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    align-items: center;
    flex-direction: row;
    gap: ${theme.remSize[200]};
  }
`;

export const info: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[200]};
`;

export const textInfo: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.remSize[25]};
  width: 10.75rem;
`;
export const detailsWrapper: ThemedFunctor = ({ theme }) => css`
  overflow: hidden;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    overflow: visible;
  }
`;

export const details: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[150]};
  flex-wrap: wrap;

  > * {
    display: flex;

    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: ${theme.color.border.neutral.default.high};
      transform: translateX(-${theme.remSize[75]});
    }
  }
`;
